import { render, staticRenderFns } from "./CbsPresentation.vue?vue&type=template&id=7f406ff8&scoped=true"
import script from "./CbsPresentation.vue?vue&type=script&lang=js"
export * from "./CbsPresentation.vue?vue&type=script&lang=js"
import style0 from "./CbsPresentation.vue?vue&type=style&index=0&id=7f406ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f406ff8",
  null
  
)

export default component.exports